import React, { useState } from "react";

const ServiceOption = ({ name, optional, onChange }) => {
  const [availability, setAvailability] = useState("Not available");
  const [chargeType, setChargeType] = useState("Fixed amount");
  const [charges, setCharges] = useState("");

  const handleAvailabilityChange = (value) => {
    setAvailability(value);
    onChange(name, { availability: value, chargeType, charges });
  };

  const handleChargeTypeChange = (value) => {
    setChargeType(value);
    onChange(name, { availability, chargeType: value, charges });
  };

  const handleChargesChange = (value) => {
    setCharges(value);
    onChange(name, { availability, chargeType, charges: value });
  };

  return (
    <div className="">
      <div className="flex justify-between items-center">
        <h3 className="text-sm font-medium text-gray-700">
          {name}
          {optional && <span className="text-gray-500 text-sm"> (Optional)</span>}
        </h3>
      </div>
      <div className="mt-2 flex items-center gap-4">
        {/* Radio Buttons */}
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name={`${name}-availability`}
            value="Not available"
            checked={availability === "Not available"}
            onChange={(e) => handleAvailabilityChange(e.target.value)}
            className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-gray-700 text-xs">Not available</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name={`${name}-availability`}
            value="Available for extra charge"
            checked={availability === "Available for extra charge"}
            onChange={(e) => handleAvailabilityChange(e.target.value)}
            className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-gray-700 text-xs">Available for extra charge</span>
        </label>
      </div>

      {/* Dropdown and Input for Charges */}
      {availability === "Available for extra charge" && (
        <div className="mt-4 space-y-4">
          {/* Dropdown */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Select Charge Type
            </label>
            <select
              value={chargeType}
              onChange={(e) => handleChargeTypeChange(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              <option>Fixed amount</option>
              <option>On consumption basis</option>
            </select>
          </div>

          {/* Input Field */}
          {chargeType === "Fixed amount" && (
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">
                Enter {name.toLowerCase()} charges
              </label>
              <input
                type="text"
                value={charges}
                onChange={(e) => handleChargesChange(e.target.value)}
                placeholder={`Enter ${name.toLowerCase()} charges`}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const ServicesExcludingPrice = ({ formData, setFormData }) => {
  const services = ["Laundry", "Water", "Wifi"];

  const handleServiceChange = (serviceName, data) => {
    setFormData((prevState) => {
      const updatedPricingAndOthers = {
        ...prevState.pricingAndOthers,
        servicesExcludingPrice: {
          ...prevState.pricingAndOthers.servicesExcludingPrice,
          [serviceName]: data,
        },
      };
      return {
        ...prevState,
        pricingAndOthers: updatedPricingAndOthers,
      };
    });
  };

  return (
    <div className="py-2">
      <h2 className="text-[15px] font-semibold text-gray-700 mb-1 ">Services Excluding Price</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {services.map((service) => (
          <ServiceOption
            key={service}
            name={service}
            optional={true}
            onChange={handleServiceChange}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicesExcludingPrice;
